<template>
	<div>
		<Navigation />
		<b-container>
			<b-row>
				<b-col col lg="12">
					<p style="margin-bottom: 0px;">Page not found</p>
					<b-card bg-variant="light">
						<b-row>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('Dashboard')" variant="outline-primary" class="title button">GO HOME</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-container>

	</div>
</template>

<script>
import Navigation from './Navigation.vue'

export default {
	data() {
		return {

		}
	},

	components: { Navigation },

	methods: {
		goTo(routeName) {
			this.$store.commit('setCurrentRoute', routeName)
			this.$router.push({name: routeName}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style>

</style>